<script>
	// From Lucide
	import { Calendar } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Calendar class={iconClass} />